import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const TabsWrapper = styled.ul`
  display: flex;
  justify-content: center;
`;

export const TabItemAnchor = styled.a`
  display: block;
  height: 32px;
  color: ${({ theme }) => theme.colors.gray800};
  text-align: center;
  ${getFontStyle('midium150_C1')};
  line-height: 32px;
`;

export const TabItem = styled.li`
  flex: 0 0 80px;
  width: 80px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-right-width: 0;

  &.active {
    border-color: ${({ theme }) => theme.colors.magenta500};
    background-color: ${({ theme }) => theme.colors.magenta100};
  }

  &.active > ${TabItemAnchor} {
    color: ${({ theme }) => theme.colors.magenta700};
  }

  &.active + & {
    border-left-color: ${({ theme }) => theme.colors.magenta500};
  }

  &:first-child {
    border-radius: 16px 0px 0px 16px;
  }

  &:last-child {
    border-right-width: 1px;
    border-radius: 0px 16px 16px 0px;
  }
`;
